/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { translateElementChildren } from 'utils/translation';

const Span = ({ children, translationKey, defaultText, ...rest }) => {
  return (
    <span {...rest}>
      {translateElementChildren(children, translationKey, defaultText)}
    </span>
  );
};

Span.propTypes = {
  children: PropTypes.node.isRequired,
  translationKey: PropTypes.string,
  defaultText: PropTypes.string,
};

export default Span;
